// react components
import React from 'react'
import PhoneInput from 'react-phone-number-input'

// styles
import 'react-phone-number-input/style.css'

// data
import {
    reduxModalStateSite,
} from 'data'

// serializers
import {
    CustomCSSProperties,
    FormFieldCustomSerializer,
} from 'serializers/site'

// props
type TemplateBlock797PhoneNumberSiteProps = {
    blockId: string
    deviceType: 'is-mobile' | 'is-tablet' | 'is-web'
    formInputObj: FormFieldCustomSerializer | undefined
    handleInputChange: (name: string, value: any, label: string, stripe_field_type: string | undefined, stringValue?: string) => void
    isEditHovered: boolean
    reduxModalSite: reduxModalStateSite
    stylesNew: CustomCSSProperties | undefined
    tabIndex: number
    value: any
}

// main
export const TemplateBlock797PhoneNumberSite: React.FC<TemplateBlock797PhoneNumberSiteProps> = React.memo(({
    blockId,
    deviceType,
    formInputObj,
    handleInputChange,
    isEditHovered,
    reduxModalSite,
    stylesNew,
    tabIndex,
    value,
}) => {

    const placeholderClass = stylesNew?.placeholderColor ? `placeholder-${stylesNew?.placeholderColor.replace(/[^a-z0-9-]/gi, '').toLowerCase()}` : ''

    return (
        <>
            {stylesNew?.placeholderColor && (
                <style>
                    {`
                    .${placeholderClass} input::placeholder {
                        color: ${stylesNew?.placeholderColor};
                        opacity: 1;
                    }
                `}
                </style>
            )}
            <PhoneInput
                id={blockId}
                className={`template-block-797${placeholderClass ? ` ${placeholderClass}` : ''}${isEditHovered ? ' is-edit-hovered' : ''} ${deviceType}`}
                defaultCountry={reduxModalSite.portfolio?.id === 594 ? 'BE' : 'FR'}  // TODO dynamic
                onChange={(e) => handleInputChange(formInputObj?.name!, e, formInputObj?.label!, formInputObj?.stripe_field_type)}
                placeholder={formInputObj?.placeholder === 'true' ? formInputObj?.label : ''}
                style={stylesNew}
                tabIndex={tabIndex}
                value={value || ''}
            />
        </>
    )
})
